import { useQueryClient } from "@tanstack/react-query";
import {
  type NewCompany,
  type NewUser,
  getCompanyListCompanyGetQueryKey,
} from "kubb";
import type React from "react";
import { ErrorBanner } from "../../components/Error/ErrorBanner";
import {
  useCreateCompany,
  useCreateCompanyAndUser,
} from "../../hooks/createEntity";
import CreateCompanyForm from "./CreateCompanyForm";

interface Props {
  onSubmit?: () => any;
}

export default function CreateCompanyContainer(
  props: Props,
): React.ReactElement {
  const queryClient = useQueryClient();
  const registerCompany = useCreateCompanyAndUser();
  const createCompany = useCreateCompany();

  const submit = async (
    new_company: NewCompany,
    new_user?: NewUser,
  ): Promise<any> => {
    if (new_user) {
      await registerCompany.update({ new_company, new_user });
    } else {
      await createCompany.update(new_company);
    }
    // Invalidate every variant of the company-list query (the selector dropdown's
    // max_items=250 fetch and the admin page's paginated fetch share this prefix).
    // Awaiting ensures active observers finish refetching before we resolve, so
    // Cypress can rely on the dropdown being up-to-date.
    await queryClient.invalidateQueries({
      queryKey: getCompanyListCompanyGetQueryKey(),
    });
    props.onSubmit?.();
  };

  return (
    <>
      <CreateCompanyForm onSubmit={submit} />
      <ErrorBanner error={registerCompany.error || createCompany.error} />
    </>
  );
}
